module.exports = "<i [attr.data-feather]=\"name\"></i>"